import { Page } from "@/components/wizard";

export default function Psychoeducation() {
  return (
    <Page narrow>
      <div data-testid="psychoeducation-page">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#142D43] tracking-tight">
          Psicoeducazione ADHD
        </h1>
        <div className="mt-8 space-y-5 text-base sm:text-[17px] text-[#374151] leading-[1.7] max-w-[680px]">
          <p>Comprendere l'ADHD è una parte importante del percorso di cura.</p>
          <p>
            La psicoeducazione aiuta a conoscere meglio il funzionamento dell'ADHD nell'età adulta, riconoscere
            le difficoltà che può determinare nella vita quotidiana e sviluppare strategie più efficaci per la
            gestione dell'attenzione, dell'impulsività, dell'organizzazione, del tempo e delle relazioni.
          </p>
          <p>Sono disponibili percorsi di psicoeducazione dedicati agli adulti con ADHD.</p>
        </div>
        <a
          href="https://arcipelago.ch"
          target="_blank"
          rel="noreferrer"
          data-testid="psychoeducation-cta-arcipelago"
          className="mt-10 inline-flex items-center justify-center w-full sm:w-auto bg-[#142D43] text-white border border-[rgba(255,255,255,0.08)] shadow-[0_2px_0_#0F2233,0_6px_14px_rgba(20,45,67,0.16),inset_0_1px_0_rgba(255,255,255,0.12)] hover:bg-[#1E3F5C] hover:shadow-[0_4px_0_#0F2233,0_10px_22px_rgba(20,45,67,0.20),inset_0_1px_0_rgba(255,255,255,0.15)] hover:-translate-y-[2px] active:shadow-[0_1px_0_#0F2233,0_3px_7px_rgba(20,45,67,0.14),inset_0_1px_2px_rgba(0,0,0,0.08)] active:translate-y-[2px] font-semibold tracking-[0.01em] px-8 rounded-[14px] transition-[background-color,transform,box-shadow] duration-[180ms] active:duration-100 text-[15px] h-[54px]"
        >
          scopri ARCIPELAGO
        </a>
      </div>
    </Page>
  );
}
